module.exports = __webpack_public_path__ + "img/组织碳因子库.635d00db.png";